<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="PostalCodeAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="
                d-flex
                justify-content-between
                align-items-center
                flex-wrap
                grid-margin
              ">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    Form Question Answer P2H
                  </h6>
                  <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->

                  <!--end::loading-data-->

                  <form class="forms-sample" @submit.prevent="submitData" method="POST">
                    <div class="
                          d-flex
                          justify-content-between
                          align-items-baseline
                          mb-2
                        "></div>

                    <div class="row mb-3">
                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Name</label>
                      </div>
                      <div class="col-lg-4">
                        <input :disabled="this.$route.query.action == 'detail'" type="text" class="form-control"
                          v-model="forms.p2h_name" required />
                        <div v-if="errors.p2h_name">
                          <div v-for="error in errors.p2h_name" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Description</label>
                      </div>
                      <div class="col-lg-4">
                        <textarea :disabled="this.$route.query.action == 'detail'" class="form-control"
                          name="p2h_description" rows="3" v-model="forms.p2h_description" required></textarea>
                        <div v-if="errors.p2h_description">
                          <div v-for="error in errors.p2h_description" :key="error" class="alert alert-primary"
                            role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="row mb-3">
                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Deployment
                          Date</label>
                      </div>
                      <div class="col-lg-4">
                        <date-range-picker :disabled="this.$route.query.action == 'detail'" style="width: 100%"
                          :locale-data="locale" v-model="deploymentDate" :opens="opens" :singleDatePicker="true"
                          :timePicker24Hour="true" :timePicker="true">
                        </date-range-picker>
                        <div v-if="errors.deployment_date">
                          <div v-for="error in errors.deployment_date" :key="error" class="alert alert-primary"
                            role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>

                    </div>




                    <div class="row mb-3">
                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Enabled</label>
                      </div>

                      <div class="col-lg-4">
                        <v-select :disabled="this.$route.query.action == 'detail'" :options="fetchEnabled"
                          v-model="enabledList" label="name" return-object></v-select>

                        <div v-if="errors.enabled">
                          <div v-for="error in errors.enabled" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>

                    </div>


                    <div class="row">
                      <div class="mt-4 col-12" v-if="showQuestion">
                        <div class="card shadow-sm rounded-3">
                          <div class="card-header d-flex justify-content-between align-items-center px-4">
                            <h6 class="mb-0">Question</h6>
                            <span class="btn btn-success" v-if="this.$route.query.action != 'detail'"
                              @click="newData">New Data</span>
                          </div>

                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-striped table-bordered align-middle" cellpadding="5">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Page</th>
                                    <th>Order</th>
                                    <th>Question</th>
                                    <th>Required</th>
                                    <th>Control Type</th>
                                    <th>Subdetails</th>
                                    <th>Aksi</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- ✅ Jika belum ada data -->
                                  <tr v-if="detailList.length === 0">
                                    <td colspan="8" class="text-center">--- Belum ada data ---</td>
                                  </tr>

                                  <!-- ✅ Jika ada data -->
                                  <tr v-for="(detail, index) in detailList" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ detail.page }}</td>
                                    <td>{{ detail.order }}</td>
                                    <td>{{ detail.question }}</td>
                                    <td>{{ detail.required }}</td>
                                    <td>{{ detail.control_type }}</td>
                                    <td>
                                      <ul>
                                        <li v-for="(sub, i) in detail.subdetails" :key="i">
                                          
                                          Radio Button : {{ sub.value }}

                                        </li>
                                      </ul>
                                    </td>
                                    <td>
                                      <span v-if="$route.query.action != 'detail'" class="btn btn-success"
                                        style="margin-right: 5px;" @click="EditDetail(detail)">Edit </span>
                                      <span v-if="$route.query.action != 'detail'" class="btn btn-danger"
                                        @click="hapusDetail(index)">Hapus</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>


                            </div>
                          </div>

                          <div class="card-footer text-end">
                            <!-- Optional footer content -->
                          </div>
                        </div>
                      </div>

                    </div>


                    <div class="card-footer d-flex justify-content-between align-items-center">
                      <!-- Tombol Back di kiri -->
                      <button class="btn btn-warning text-black fw-bolder btn-icon-text" @click="backForm"
                        type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <!-- Tombol Question dan Simpan di kanan -->
                      <div>
                        <button class="btn btn-danger text-white fw-bolder btn-icon-text me-2" @click="goQuestion"
                          type="button">
                          {{ showQuestion == true ? 'Hide Question' : 'Show Question' }}
                        </button>

                       

                        <v-template v-if="this.$route.query.action != 'detail'">
                          <button v-if="!isLoading"  class="btn btn-primary btn-sm"
                          type="submit">
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                        </v-template>


                        <div v-if="isLoading" class="d-flex align-items-center">
                          <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                          <strong>{{ $t("loadingTxt") }}...</strong>
                        </div>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>









          </div>
        </div>
        <!--end::content-->


        <modal-question-answer @showDataFromModal="handleDetail" :showModal="showModal" :data="datas"
          @closeModal="closeMyModal" :action="action"></modal-question-answer>

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import ModalApproveChecklistP2H from "@/components/modal/modalQuestionP2h.vue";

export default {
  name: "FormQuestionAnswerP2h",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
    "modal-question-answer": ModalApproveChecklistP2H
  },
  data() {
    const startDate = moment().startOf('month').format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    return {
      action: "create",
      datas: [],
      detailList: [],
      locale: {
        format: "dd mmm yyyy H:MM:ss",
      },
      showQuestion: false,
      showModal: false,
      details: [],
      fetchEnabled: [
        {
          name: 'yes',
        },
        {
          name: 'no',
        }

      ],
      enabledList: {
        name: "no"
      },

      deploymentDate: {
        startDate,
        endDate
      },
      opens: "center",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      regionCode: "",
      forms: { name: "", usernmae: "" },
    };
  },
  watch: {},
  methods: {

    closeMyModal() {
      this.showModal = false;
      //this.detailList = this.detailList.sort((a, b) => a.order - b.order);

    },
    resetForm() {
      this.forms.country = "";
      this.forms.province = "";
      this.forms.city = "";
      this.forms.city_type = "";
      this.forms.district = "";
      this.forms.sub_district = "";
      this.forms.postal_code = "";
    },

    goQuestion() {
      this.showQuestion = !this.showQuestion
    },

    newData() {
      this.showModal = true;
      this.datas = null;
      this.action = "create";
    },

    EditDetail(row) {
      this.showModal = true;
      this.datas = row;
      this.action = "edit";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ChecklistP2HController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },




    handleDetail(detail) {
      if (detail.m_p2h_question_detail_id == null) {
        // Jika ID null, langsung tambahkan detail baru
        this.detailList.push(detail);
      } else {
        const index = this.detailList.findIndex(item =>
          item.m_p2h_question_detail_id === detail.m_p2h_question_detail_id
        );

        if (index !== -1) {
          // Jika sudah ada, update datanya
          this.detailList.splice(index, 1, detail);
        } else {
          // Jika belum ada, tambahkan baru
          this.detailList.push(detail);
        }
      }

         this.detailList = this.detailList.details.sort((a, b) => {
          if (a.page !== b.page) {
            return a.page - b.page;
          } else {
            return a.order - b.order;
          }
        });

    },
    hapusDetail(index) {
      this.detailList.splice(index, 1); // hapus berdasarkan index
    },

    backForm() {


      this.$router.push('/ct-orders/ct-question-answer-p2h');

    },

    submitData() {
      this.forms.deployment_date = moment(this.deploymentDate.startDate).format(
        "YYYY-MM-DD HH:mm"
      );
      console.log(this.deploymentDate);
      console.log(this.enabledList);
      this.forms.details = this.detailList;
      this.forms.enabled = this.enabledList.name;
      this.fade(true);


      if (this.$route.query.action == 'edit') {
        var params = this.$onBehind(this.$route.query.params);
        let baseURI = this.$settings.endPointLincMobile + "web/m-p2h-question/update/" + params;
        this.$http
          .patch(baseURI, this.forms)
          .then((response) => {
            this.loading();
            if (response.data.status === 200) {
              //this.resetForm();
              this.errors = [];
              //console.log(response.data.datas.user_id);
              //var params = this.$onRandom(response.data.datas.postal_code_id);
              this.$router.push('/ct-orders/ct-question-answer-p2h');
              // this.success('Berhasil');
            } else {
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
          })
          .catch((error) => {
            this.loading();
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push("/page-not-found");
              }
            }
            //this.resetForm();
          });
      } else {

        let baseURI = this.$settings.endPointLincMobile + "web/m-p2h-question/create";
        this.$http
          .post(baseURI, this.forms)
          .then((response) => {
            this.loading();
            if (response.data.status === 200) {
              //this.resetForm();
              this.errors = [];
              //console.log(response.data.datas.user_id);
              //var params = this.$onRandom(response.data.datas.postal_code_id);
              this.$router.push('/ct-orders/ct-question-answer-p2h');
              // this.success('Berhasil');
            } else {
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
          })
          .catch((error) => {
            this.loading();
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push("/page-not-found");
              }
            }
            //this.resetForm();
          });
      }
      //let formData = new FormData();



    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    loadData(id) {
      const baseURI = this.$settings.endPointLincMobile + "web/m-p2h-question/detail/" + id;
      return this.$http.get(baseURI).then((response) => {

        this.forms = response.data.datas;



        this.deploymentDate = {
          startDate: new Date(this.forms.deployment_date),
          endDate: new Date(this.forms.deployment_date),
        };

        this.enabledList = {
          name: this.forms.enabled
        }


        this.detailList = this.forms.details.sort((a, b) => {
          if (a.page !== b.page) {
            return a.page - b.page;
          } else {
            return a.order - b.order;
          }
        });

        //this.detailList = this.forms.details.sort((a, b) => a.order - b.order);

        // this.form={ name: 'asep', usernmae:res.username };
      });
    },


    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    var params = this.$onBehind(this.$route.query.params);

    if (this.$route.query.action == 'edit' || this.$route.query.action == 'detail' || this.$route.query.action == 'copy') {
      this.loadData(params);
      this.showQuestion = true;
    }


  },
};
</script>
<style scoped></style>